import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getBusinessType from '@results/selectors/getBusinessType';
import { categoryType } from '@services/routes.service';

export const EVENTS = {
  CLOSED: 'menu_section.closed',
  CLICKED: 'menu_section.clicked',
};

const trackMenuSection = event => (_, getState) => {
  try {
    const { location } = window;
    const state = getState();
    const shopId = getShopId(state);
    const businessType = getBusinessType(state);
    const screenType = categoryType(location);
    const payload = {
      shopId,
      businessType,
      screenType,
    };
    track(event, payload);
  } catch (error) {
    logError(event, error);
  }
};

export default trackMenuSection;
